import { MeshPhysicalMaterial } from "three";

export const HumanoidMaterial = async (args = {}) => {
	const material = new MeshPhysicalMaterial({
		color: 0xffffff,
		metalness: 1.0,
		roughness: 0.0,
		reflectivity: 1.0,
		clearcoat: 1,
		clearcoatRoughness: 0.1,
		envMapIntensity: 0.1,
		dispersion: 1,
	});

	return material;
};
